import dayjs from 'dayjs'

import { GOOGLE_CALENDAR_AUTH_CLIENT_ID } from 'interfaces/constants'

import { PATHS } from '../../../api/paths'
import { getApiTrackingPath } from '../../../api/utils/paths'

export const getPeriodEndDate = (
  periodStartDate: Date,
  periodLength: number,
) => {
  return dayjs(periodStartDate)
    .add(periodLength - 1, 'day')
    .toDate()
}
export const getOvulationDate = (periodStartDate: Date) => {
  return dayjs(periodStartDate).subtract(14, 'day').toDate()
}
export const getFertileDates = (ovulationDate: Date) => {
  const fertileDateStart = dayjs(ovulationDate).subtract(5, 'day').toDate()
  const fertileDateEnd = dayjs(ovulationDate).add(1, 'day').toDate()
  return {
    fertileDateStart,
    fertileDateEnd,
  }
}

export const isDateStartCycle = (
  date: Date,
  startPeriodDate: Date,
  cycle: number,
) => {
  let syncPeriodStart = startPeriodDate
  const down = dayjs(date).isBefore(dayjs(startPeriodDate))
  while (true) {
    if (dayjs(syncPeriodStart).isSame(dayjs(date))) {
      return true
    } else {
      if (down && dayjs(syncPeriodStart).isBefore(dayjs(date))) {
        return false
      }
      if (!down && dayjs(date).isBefore(dayjs(syncPeriodStart))) {
        return false
      }
      syncPeriodStart = dayjs(syncPeriodStart)
        .add(!down ? cycle : -1 * cycle, 'day')
        .toDate()
    }
  }
}
export const isDateOvulation = (
  date: Date,
  startPeriodDate: Date,
  cycle: number,
) => {
  let syncOvulationDate = getOvulationDate(startPeriodDate)
  const down = dayjs(date).isBefore(dayjs(syncOvulationDate))
  while (true) {
    if (dayjs(syncOvulationDate).isSame(dayjs(date))) {
      return true
    } else {
      if (down && dayjs(syncOvulationDate).isBefore(dayjs(date))) {
        return false
      }
      if (!down && dayjs(date).isBefore(dayjs(syncOvulationDate))) {
        return false
      }
      syncOvulationDate = dayjs(syncOvulationDate)
        .add(!down ? cycle : -1 * cycle, 'day')
        .toDate()
    }
  }
}
export const isDateInCycle = (
  date: Date,
  startPeriodDate: Date,
  cycle: number,
  periodLength: number,
) => {
  let syncPeriodStart = dayjs(startPeriodDate).startOf('day').toDate()
  const syncDate = dayjs(date).startOf('day').toDate()
  const currentDateBeforePeriod = dayjs(date).isBefore(dayjs(startPeriodDate))
  while (true) {
    let syncPeriodEnd = getPeriodEndDate(syncPeriodStart, periodLength)
    if (
      dayjs(syncDate).isBetween(
        dayjs(syncPeriodStart),
        dayjs(syncPeriodEnd),
        'day',
        '[]',
      )
    ) {
      return true
    } else {
      if (
        currentDateBeforePeriod &&
        dayjs(syncPeriodEnd).isBefore(dayjs(syncDate))
      ) {
        return false
      }
      if (
        !currentDateBeforePeriod &&
        dayjs(syncDate).isBefore(dayjs(syncPeriodStart))
      ) {
        return false
      }
      syncPeriodStart = dayjs(syncPeriodStart)
        .add(!currentDateBeforePeriod ? cycle : -1 * cycle, 'day')
        .toDate()
      syncPeriodEnd = getPeriodEndDate(syncPeriodStart, periodLength)
    }
  }
}
export const isDateInCycleForAd = (
  date: Date,
  startPeriodDate: Date,
  cycle: number,
  periodLength: number,
) => {
  let syncPeriodStart = dayjs(startPeriodDate).startOf('day').toDate()
  const syncDate = dayjs(date).startOf('day').toDate()
  const currentDateBeforePeriod = dayjs(date).isBefore(dayjs(startPeriodDate))
  while (true) {
    let syncPeriodEnd = getPeriodEndDate(syncPeriodStart, periodLength)
    // if start of period is before current date or
    // period start same as current date and date is before end period + 1
    if (
      dayjs(syncDate).isBetween(
        dayjs(syncPeriodStart).subtract(8, 'day'),
        dayjs(syncPeriodEnd),
        'day',
        '[]',
      )
    ) {
      return true
    } else {
      if (
        (currentDateBeforePeriod &&
          dayjs(syncPeriodEnd).isBefore(dayjs(syncDate))) ||
        (!currentDateBeforePeriod &&
          dayjs(syncDate).isBefore(dayjs(syncPeriodStart).subtract(8, 'day')))
      ) {
        return false
      }
      syncPeriodStart = dayjs(syncPeriodStart)
        .add(!currentDateBeforePeriod ? cycle : -1 * cycle, 'day')
        .toDate()
      syncPeriodEnd = getPeriodEndDate(syncPeriodStart, periodLength)
    }
  }
}
export const isDateInFertile = (
  date: Date,
  startPeriodDate: Date,
  cycle: number,
) => {
  const syncDate = dayjs(date).startOf('day')
  let syncOvulationDate = getOvulationDate(
    dayjs(startPeriodDate).startOf('day').toDate(),
  )
  const fertileDates = getFertileDates(syncOvulationDate)
  let syncFertileDateStart = fertileDates.fertileDateStart
  let syncFertileDateEnd = fertileDates.fertileDateEnd
  const down = dayjs(syncDate).isBefore(dayjs(syncFertileDateStart))
  while (true) {
    if (
      (dayjs(syncFertileDateStart).isBefore(syncDate) ||
        dayjs(syncFertileDateStart).isSame(syncDate)) &&
      dayjs(syncDate).isBefore(dayjs(syncFertileDateEnd).add(1, 'day'))
    ) {
      return true
    } else {
      if (down && dayjs(syncFertileDateEnd).isBefore(dayjs(syncDate))) {
        return false
      }
      if (!down && dayjs(syncDate).isBefore(dayjs(syncFertileDateStart))) {
        return false
      }
      syncOvulationDate = dayjs(syncOvulationDate)
        .add(!down ? cycle : -1 * cycle, 'day')
        .toDate()
      const nextFertileDates = getFertileDates(syncOvulationDate)
      syncFertileDateStart = nextFertileDates.fertileDateStart
      syncFertileDateEnd = nextFertileDates.fertileDateEnd
    }
  }
}

export enum DateMenstrualInfoTypeEnum {
  normal = 1,
  fertile = 2,
  ovulation = 3,
  period = 4,
}

export type DateMenstrualInfo = {
  diffOvulation: number
  diffPeriod: number
  rate: number
  type: DateMenstrualInfoTypeEnum
}

export const getNextOvulationPeriodDate = (
  currentDate: Date,
  startOvulationPeriodDate: Date,
  cycle: number,
) => {
  let ovulationPeriodDate = new Date(startOvulationPeriodDate)
  const down = dayjs(currentDate).isBefore(ovulationPeriodDate)
  while (true) {
    if (!down && dayjs(currentDate).isSameOrBefore(ovulationPeriodDate)) {
      break
    }
    if (
      down &&
      (dayjs(ovulationPeriodDate).isBefore(currentDate) ||
        dayjs(currentDate).isSame(ovulationPeriodDate))
    ) {
      ovulationPeriodDate = dayjs(ovulationPeriodDate)
        .add(cycle, 'day')
        .toDate()
      break
    }
    ovulationPeriodDate = dayjs(ovulationPeriodDate)
      .add(!down ? cycle : -1 * cycle, 'day')
      .toDate()
  }
  return ovulationPeriodDate
}

export const getDateMenstrualInfo = (
  date: Date,
  startPeriodDate: Date,
  cycle: number,
  periodLength: number,
): DateMenstrualInfo => {
  const syncDate = dayjs(date).startOf('day').toDate()
  const syncPeriodStart = getNextOvulationPeriodDate(
    syncDate,
    dayjs(startPeriodDate).startOf('day').toDate(),
    cycle,
  )
  const syncOvulationDate = getNextOvulationPeriodDate(
    syncDate,
    getOvulationDate(dayjs(startPeriodDate).startOf('day').toDate()),
    cycle,
  )
  const diffDaysOvulation = dayjs(syncOvulationDate).diff(
    dayjs(syncDate),
    'day',
  )
  let rate = 2.1
  let type = DateMenstrualInfoTypeEnum.normal
  if (diffDaysOvulation === 1) rate = 23.5
  if (diffDaysOvulation === 2) rate = 19.3
  if (diffDaysOvulation === 3) rate = 10.7
  if (diffDaysOvulation === 4) rate = 7.8
  if (diffDaysOvulation === 5) rate = 6.4
  if (diffDaysOvulation === 0) rate = 15.7
  if (diffDaysOvulation === -1) rate = 5.7
  if (diffDaysOvulation >= -1 && diffDaysOvulation <= 5)
    type = DateMenstrualInfoTypeEnum.fertile
  if (diffDaysOvulation === 0) type = DateMenstrualInfoTypeEnum.ovulation
  const diffDaysPeriod = dayjs(syncPeriodStart).diff(dayjs(syncDate), 'day')
  const isMenstrual = isDateInCycle(
    syncDate,
    syncPeriodStart,
    cycle,
    periodLength,
  )
  if (isMenstrual) {
    rate = 1
    type = DateMenstrualInfoTypeEnum.period
  }

  return {
    diffOvulation: diffDaysOvulation,
    diffPeriod: diffDaysPeriod,
    rate,
    type,
  }
}

export const DateToInputValue = (date: Date) => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    '0',
  )}-${String(date.getDate()).padStart(2, '0')}`
}

export const getDaysDifference = (firstDate: Date, secondDate: Date) => {
  const diffTime = Math.abs(secondDate.getTime() - firstDate.getTime())
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return diffDays
}

export const getGoogleCalendarAuthLink = (
  baseUrl: string,
  redirectUri: string,
  googleMail?: string,
  passthroughState?: { [key: string]: string },
) => {
  return (
    'https://accounts.google.com/o/oauth2/v2/auth?' +
    'scope=https%3A//www.googleapis.com/auth/calendar&' +
    'response_type=token&' +
    `redirect_uri=${encodeURIComponent(baseUrl)}&` +
    `state=${encodeURIComponent(
      new URLSearchParams({
        redirect: redirectUri,
        ...passthroughState,
      }).toString(),
    )}&` +
    `client_id=${GOOGLE_CALENDAR_AUTH_CLIENT_ID}${
      googleMail ? `&login_hint=${googleMail}` : ''
    }`
  )
}

export const createOvulationEvents = ({
  token,
  cycle,
  day, // in dd-MM-yyyy
  user_id,
  period,
  method,
}: {
  token: string
  method: number
  cycle: number
  period: number
  day: string
  user_id: string
}) =>
  getApiTrackingPath(PATHS.HEALTH_TOOL.OVULATION_CREATE_EVENT, {
    method,
    day,
    cycle,
    period,
    token,
    user_id,
  })
